import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '../../../lib/api-fetcher';
import type { PaginatedResponse } from '@repo/types';

export function useAreaGroups(filters?: any) {
  return useQuery({
    queryKey: ['settings', 'area-groups', filters],
    queryFn: async () => {
      const params = filters ? '?' + new URLSearchParams(filters as Record<string, string>).toString() : '';
      return fetcher.get<PaginatedResponse<any>>(`/staff/v1/settings/area-groups${params}`);
    },
  });
}

export function useCreateAreaGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: { name: string; code: string }) => {
      return fetcher.post('/staff/v1/settings/area-groups', data);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'area-groups'] });
    },
  });
}

export function useDeleteAreaGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return fetcher.delete(`/staff/v1/settings/area-groups/${id}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'area-groups'] });
      qc.invalidateQueries({ queryKey: ['settings', 'areas'] });
    },
  });
}

export function useAreas(filters?: any) {
  return useQuery({
    queryKey: ['settings', 'areas', filters],
    queryFn: async () => {
      const params = filters ? '?' + new URLSearchParams(filters as Record<string, string>).toString() : '';
      return fetcher.get<PaginatedResponse<any>>(`/staff/v1/settings/areas${params}`);
    },
  });
}

export function useCreateArea() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: { name: string; code: string; areaGroupId: string }) => {
      return fetcher.post('/staff/v1/settings/areas', data);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'areas'] });
    },
  });
}

export function useDeleteArea() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return fetcher.delete(`/staff/v1/settings/areas/${id}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'areas'] });
    },
  });
}
